if (!window.__ctrKlaviyoRatingInit) {
  window.__ctrKlaviyoRatingInit = true

  let savedLabelText = ''

  function modifyWidget(widget) {
    const ariaLabel = widget.getAttribute('aria-label') || ''
    const originalRating = parseFloat(ariaLabel.split(',')[0].trim().replace(' stars', ''))
    if (Number.isNaN(originalRating)) return

    const roundedRating = Math.round(originalRating * 10) / 10
    const ratingText = roundedRating.toFixed(1)

    const ratingElement = document.createElement('span')
    ratingElement.className = 'kl-rating-value'
    ratingElement.textContent = ratingText

    widget.insertBefore(ratingElement, widget.firstChild)

    const labelElement = widget.querySelector('.kl_reviews__star_rating_widget__label')
    if (labelElement) {
      const reviewsCount = labelElement.textContent.split(' ')[0]
      savedLabelText = reviewsCount + ' reviews'
      labelElement.textContent = savedLabelText
      labelElement.style.display = 'none'
    }

    const reviewsElement = document.createElement('span')
    reviewsElement.className = 'kl-reviews-text'
    reviewsElement.textContent = savedLabelText
    widget.appendChild(reviewsElement)

    widget.classList.add('modified')
  }

  function modifySummaryDiv(div) {
    const newLabel = document.createElement('span')
    newLabel.className = 'kl-summary-reviews-text'
    newLabel.textContent = savedLabelText

    div.innerHTML = ''
    div.parentElement.appendChild(newLabel)

    div.classList.add('modified')
  }

  const observer = new MutationObserver(function () {
    document.querySelectorAll('.kl_reviews__star_rating_widget:not(.modified)').forEach((widget) => {
      modifyWidget(widget)
    })

    document.querySelectorAll('.kl_reviews__summary__stars__count:not(.modified)').forEach((summaryDiv) => {
      if (savedLabelText) modifySummaryDiv(summaryDiv)
    })
  })

  observer.observe(document.body, { childList: true, subtree: true })

  const style = document.createElement('style')
  style.textContent = `
    .kl_reviews__summary__stars__count {
      display: none;
    }
  `
  document.head.appendChild(style)
}
